import React, { FC } from 'react';
import { Button } from 'antd';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { passwordResetRequest } from '~/routes';

import { ResetPasswordFailIcon } from '~/img';
import PasswordResetLayout from '~/layout/PasswordResetLayout';

const PasswordResetTokenExpired: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('passwordReset');
  const history = useHistory();

  const onClick = () => {
    history.replace(`/${passwordResetRequest}`);
  };

  return (
    <PasswordResetLayout
      icon={<ResetPasswordFailIcon />}
      title={t('Oops!')}
      subtitle={t('Sorry, looks like the password recovery link has expired. Please try again.')}
      withGoToLogin
    >
      <Button type="primary" size="large" onClick={onClick}>
        {t('Reset password')}
      </Button>
    </PasswordResetLayout>
  );
};

export default PasswordResetTokenExpired;
